import React from 'react'
import { ReactComponent as VisaIcon } from "src/assets/icons/visa.svg";
import { ReactComponent as MasterCardIcon } from "src/assets/icons/master-card.svg";

const PaymentIcons = () => {
  return (
    <div className='payment-icons d-flex gap-2 align-items-center'>
        <VisaIcon className='large-icon'/>
        <MasterCardIcon className='large-icon'/>
    </div>
  )
}

export default PaymentIcons